import MuiTypography, { TypographyProps } from '@mui/material/Typography';

export const Typography = ({ children, ...props }: TypographyProps) => (
  <MuiTypography {...props}>{children}</MuiTypography>
);

export type { TypographyProps };
export type { TypographyVariant } from '@mui/material/styles';
